import { AxiosError } from 'axios';
import { ReliantResponse } from 'interface/apiInterface';
import { baseService } from 'services';
import {
  commonError,
  createOrganizationEP,
  listOrganizationsForUserEP,
} from 'services/constants';
import { IErrorResponse, ISuccessResponse } from 'interface/apiInterface';
import {
  IOrganizationResponse,
  IListOrganizationsForUserResponse,
  IRegisterOrganization,
} from 'interface/organizationInterface';

export const createOrganization = async (
  data: IRegisterOrganization,
): Promise<
  ISuccessResponse<IOrganizationResponse> | IErrorResponse<AxiosError>
> => {
  try {
    const response = await baseService.post(createOrganizationEP, data);
    return response;
  } catch (error) {
    return commonError(error as AxiosError, true);
  }
};

export const listOrganizationsForUser = async (): Promise<
  ReliantResponse<IListOrganizationsForUserResponse>
> => {
  try {
    const response = await baseService.post<IListOrganizationsForUserResponse>(
      listOrganizationsForUserEP,
      {},
    );
    return new ReliantResponse(response);
  } catch (error) {
    return new ReliantResponse(undefined, error as AxiosError);
  }
};
